import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-coverletter',
  templateUrl: './coverletter.component.pug',
  styleUrls: ['./coverletter.component.styl']
})
export class CoverletterComponent implements OnInit {

	public constructor(private titleService: Title) { }
  
	title: string;
	subtitle: string;
	tirtitle: string;
	company: string;

	ngOnInit() {
		this.title='Fullscript';
		this.subtitle='Human Resources';
		this.titleService.setTitle("Liam Hogan's Cover Letter");
		this.tirtitle='';
		this.company='Fullscript';
	}

}
